import React, { useState, useEffect } from "react";
import "./StepProgressBar.css";
import { Popover } from "antd";

const StepProgressBar = ({
  achievedValue,
  targetValue,
  currentStep,
  stepData,
}) => {
  console.log("stepData", achievedValue, targetValue, currentStep, stepData);
  const [state, setState] = useState({
    achievedValue: achievedValue || 0,
    targetValue: targetValue || 100,
    currentStep: currentStep || 0,
    stepData: stepData || [
      { text: "Step 1", label: "0%" },
      { text: "Step 2", label: "25%" },
      { text: "Step 3", label: "50%" },
      { text: "Step 4", label: "75%" },
      { text: "Step 5", label: "100%" },
    ],
  });

  useEffect(() => {
    setState({
      ...state,
      achievedValue: achievedValue || 0,
      targetValue: targetValue || 100,
    });
  }, [achievedValue, targetValue, currentStep, stepData]);

  const currentStepIndex = Math.min(
    Math.max(Math.floor(state.currentStep), 0),
    state.stepData.length - 1
  );

  const calculateWidth = (currentIndex) => {
    const currentTier =
      state.stepData[currentIndex] !== undefined
        ? state.stepData[currentIndex]
        : 0;
    const prevTierValue =
      currentIndex > 0 ? state.stepData[currentIndex - 1].value : 0;

    let progress = 0;

    if (
      currentIndex > 1 && state.achievedValue >= currentTier !== undefined
        ? currentTier.value
        : 0
    ) {
      progress =
        ((state.achievedValue - prevTierValue) /
          (currentTier.value - prevTierValue)) *
        100;
    } else {
      progress =
        ((state.achievedValue - prevTierValue) /
          (currentTier.value - prevTierValue)) *
        100;
    }

    return Math.min(progress, 100);
  };

  return (
    <div className="step-progress-bar">
      <div className="step-details">
        <div className="top-section">
          {stepData.map((step, index) => (
            <div
              key={index}
              className={`step-label ${index === currentStepIndex ? "active" : "inactive"
                }`}
            >
              {step.text}
            </div>
          ))}
        </div>
      </div>
      <div className="progress-step-section">
        {stepData.map((step, index) => {
          const stepValue = (index / (stepData.length - 1)) * state.targetValue;
          //const isActive = state.achievedValue >= stepValue;

          const isActive = state.achievedValue >= step.value;

          return (
            <Popover
              content={`Bonus Amt: $${step.bonus_amount}
          `}
              placement="top"
            >
              <div
                key={index}
                data-stepCount={index}
                data-stepValue={
                  (index / (stepData.length - 1)) * state.targetValue
                }
                data-achievedValue={state.achievedValue}
                data-targetValue={state.targetValue}
                className={`progress-step ${isActive ? "active" : "inactive"}`}
              >
                {isActive ? (
                  <svg
                    width="7"
                    height="6"
                    viewBox="0 0 7 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.84681 0.935631L2.89734 3.88905L1.71952 2.70747L1.71954 2.70745L1.7175 2.70548C1.66374 2.65355 1.60027 2.61271 1.53073 2.58531C1.46119 2.5579 1.38693 2.54446 1.31219 2.54575C1.23745 2.54705 1.1637 2.56305 1.09515 2.59284C1.02659 2.62264 0.964578 2.66565 0.912645 2.71941C0.860712 2.77317 0.819877 2.83663 0.792471 2.90618C0.765065 2.97572 0.751624 3.04998 0.752917 3.12472C0.75421 3.19946 0.770211 3.27321 0.800007 3.34176C0.829616 3.40989 0.872273 3.47155 0.925566 3.52329L2.49949 5.09721C2.49957 5.09729 2.49965 5.09737 2.49973 5.09745C2.55176 5.14984 2.61363 5.19144 2.6818 5.21984C2.75006 5.24828 2.82329 5.26292 2.89724 5.26292C2.9712 5.26292 3.04442 5.24828 3.11268 5.21984C3.18084 5.19144 3.24271 5.14985 3.29474 5.09747C3.29482 5.09738 3.29491 5.0973 3.29499 5.09721L6.6399 1.7523C6.69565 1.70027 6.74019 1.6374 6.7708 1.56753L6.6334 1.50734L6.7708 1.56753C6.80184 1.49666 6.81786 1.42013 6.81786 1.34277C6.81786 1.2654 6.80184 1.18887 6.77080 1.11801L6.63340 1.17819L6.77080 1.11801C6.74020 1.04816 6.69567 0.985298 6.63995 0.933274C6.58836 0.881876 6.52724 0.84102 6.46 0.813006C6.39173 0.784565 6.31851 0.769922 6.24455 0.769922C6.17060 0.769922 6.09738 0.784565 6.02911 0.813006C5.96095 0.841401 5.89908 0.882989 5.84706 0.935377C5.84697 0.935461 5.84689 0.935546 5.84681 0.935631Z"
                      fill="white"
                      stroke="white"
                      strokeWidth="0.3"
                    />
                  </svg>
                ) : (
                  <div className="circle" />
                )}
              </div>
            </Popover>
          );
        })}
      </div>
      <div className="progress-container">
        {stepData.map((step, index) => (
          <div className="progress-bar-step">
            <div
              key={index}
              className="progress-bar"
              style={{
                width: `${index > 0 ? calculateWidth(index) : 0}%`,
              }}
            />
          </div>
        ))}
      </div>
      <div className="step-details">
        <div className="bottom-section">
          {stepData.map((step, index) => (
            <div
              key={index}
              className={`step-label ${index === currentStepIndex ? "active" : ""
                }`}
            >
              {step.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepProgressBar;
